export default {
  isAuthenticated: false
}
